export default {
  isAuthenticated: false
}
